// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchMenu":"FD","selections":"GD","pillsDesktopSearchMenu":"HD"};